/**
 * Utilitaires pour filtrer les référents selon les règles métier
 * 
 * SCOPE : Module Rapport uniquement
 * 
 * Règles métier :
 * - AFFICHAGE : Tous les référents (y compris refusés)
 * - TAUX : Référents éligibles (status !== 'Refusé')
 * - SCORES : Référents complétés (status === 'Complété')
 */

export interface Referent {
  id: string;
  status: string;
  [key: string]: any;
}

/**
 * Retourne tous les référents sans filtre
 * Utilisé pour l'affichage (y compris les refusés)
 */
export function getAllReferents(referents: Referent[]): Referent[] {
  return referents;
}

/**
 * Retourne les référents éligibles (hors refusés)
 * Utilisé pour les calculs de TAUX (completion rate, response rate)
 * 
 * SCOPE : Module Rapport uniquement
 */
export function getEligibleReferents(referents: Referent[]): Referent[] {
  return referents.filter(r => r.status !== 'Refusé');
}

/**
 * Retourne les référents complétés uniquement
 * Utilisé pour les calculs de SCORES (fiabilité, moyennes)
 * 
 * SCOPE : Module Rapport uniquement
 */
export function getScoredReferents(referents: Referent[]): Referent[] {
  return referents.filter(r => r.status === 'Complété');
}

/**
 * Retourne les flags de disponibilité des données
 * Permet d'afficher "Aucune donnée éligible" dans l'UI
 * 
 * SCOPE : Module Rapport uniquement
 */
export function getDataAvailabilityFlags(referents: Referent[]): {
  hasEnoughDataForRates: boolean;
  hasEnoughDataForScores: boolean;
} {
  const eligibleReferents = getEligibleReferents(referents);
  const scoredReferents = getScoredReferents(referents);

  return {
    hasEnoughDataForRates: eligibleReferents.length > 0,
    hasEnoughDataForScores: scoredReferents.length > 0,
  };
}
